import { TrumpfUxConfig } from "./globals";

export const CONFIG_DEFAULT: TrumpfUxConfig = {
    theme: "web",
    assetPath: "./themes/",
    logLevel: "warn",
    setLogLevel: (level: "debug" | "info" | "warn" | "error") => {
        if (typeof window !== "undefined" && window.trumpf) {
            window.trumpf.ux.logLevel = level;
        }
    }
};
